import {createApp} from 'vue'
import { createPinia } from 'pinia';
import { useAuthStore } from '@/stores';
import {router} from "@/helpers/router";
import Notifications from 'notiwind'
import App from './App.vue'
import {setup} from "@/setupEcho";
import './assets/input.css'

const app = createApp(App);

app.use(createPinia());

router.beforeEach(async (to) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login','/reset/password','/password/change/'];
    const authRequired = !publicPages.includes(to.path);
    const auth = useAuthStore();

    if (authRequired && !auth.user) {
        auth.returnUrl = to.fullPath;
        return '/login';
    }

});
app.use(router);
app.use(Notifications)
setup();

app.mount('#app')

